import { Greeting } from '@/presentation/components/Greeting'
import { InviteToasts } from './components/InviteToasts'
import { LinkCard } from './components/LinkCard'
import { ReferralCard } from './components/ReferralCard'
import { useInviteViewModel } from './hooks/useInviteViewModel'

/**
 * 邀请页面
 * 通过 useInviteViewModel 整合业务逻辑和状态
 */
export default function Invite() {
  const { greeting, referralCard, linkCard, toasts } = useInviteViewModel()

  return (
    <div
      className='relative flex w-full flex-col items-center bg-white px-5 pb-10'
      data-testid='invite-page'
    >
      <Greeting {...greeting} />

      <ReferralCard {...referralCard} />

      <LinkCard {...linkCard} />

      <InviteToasts {...toasts} />
    </div>
  )
}
